import React from 'react';
import TextField from 'material-ui/TextField';

const TextFilterField = props => (
  <TextField
    id={`filter-${props.name}`}
    name={props.name}
    type={props.type ? props.type : 'text'}
    value={props.filter ? props.filter.value : ''}
    onChange={(event, newValue) => props.onFilterChange(newValue)}
    disabled={props.disabled}
  />

);

export default TextFilterField;



// WEBPACK FOOTER //
// ./src/components/filters/TextFilterField.js